import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App, applySiteMetadata } from "./App";
import { siteRoute } from "./routing";
import "@perprotocol/ui/foundation.css";
import "./styles.css";

const route = siteRoute(window.location.pathname);
applySiteMetadata(route);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App route={route} />
  </StrictMode>,
);
